import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/industries/healthtech/original-page.tsx");
